import React, { Component } from 'react';
import Card from './Components/Card/Card';
import Header from './Components/Header/Header';
import './App.css';
import { Row, Col } from 'react-bootstrap';
import Request from 'superagent';
import {NotificationContainer, NotificationManager} from 'react-notifications';
import 'react-notifications/lib/notifications.css';

class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      name : "",
      email : "",
      message : ""
    }
  }

  handleSubmit = () => {
    NotificationManager.info('Sending...', '');
    var url = 'https://sx76ng05kg.execute-api.us-east-1.amazonaws.com/1';
    var data = {
      name : this.state.name,
      email : this.state.email,
      message : this.state.message
    };
    
    Request
    .post(url)
    .send(data) // sends a JSON post body
    .set('accept', 'json')
    .then(
      () => {
        this.setState({
          name : "",
          email : "",
          message : ""
        });
        NotificationManager.success('Thank You!', '');
      }
    );
  }

  handleChange = (e) => {
    let change = { [e.target.name] : e.target.value };
    this.setState (change);
  }


  render() {
    return (
      <div className="App">
        <Header />
        <div className="main">
          <Row className="equal">
            <Col xs={12} md={4}>
                <Card type="industrialIoT" />
            </Col>
            <Col xs={12} md={4}>
              <Card type="IoTProduct"/>
            </Col>
            <Col xs={12} md={4}>
              <Card type="modernWebsites"/>
            </Col>
          </Row>
          <Row>
            <Col xs={12} md={12}>
              <h2>Industrial IoT</h2>
            </Col>
          </Row>
          <Row className='industrial-iot'>
            <Col xs={12} md={9}>
              <p>
                Machine communication with other machines in nothing new. Industry has had this capability for several decades. Early machines and processing 
                equipment used in industrial settings gathered data and readings from sensors and then shared it with other machines via telephone lines.
              </p>

              <p>
                But like most technology in its early stages, this capability was often cost prohibitive, and beyond the reach of many smaller companies. Today 
                that is all changed. Advances in electronics technology have resulted in high efficiency, low cost, and powerful computing solutions that are now 
                available at a lower, more affordable costs.
              </p>

              <p>
                Sensor technology has also advanced, with accurate, low cost sensors that can sense everything from presence, motion, rotation, light, sound, and 
                even air quality. Advancements in video capturing technology have also contributed to this scene, with reliable, high definition digital cameras 
                that can capture and transmit high quality images available for only a few dollars.
              </p>

              <p>
                Industrial IoT is the combined application of these technologies in industrial settings. Sensors and microcontroller boards are placed in strategic 
                areas of industrial processes to capture and transmit their data to other machines for them to act upon. Sensor data is also sent to cloud based 
                servers, where it is aggregated and made available to managers and engineers in real time.
              </p>

              <p>
                Whether your company is in manufacturing, oil and gas, environmental, retail, logistics, or a different industry, from shop floor to front 
                office, we provide monitoring and control solutions that drive business. We deliver essential data to decision makers in near real time, 
                maximizing your bottom line. 
              </p>
            </Col>
            <Col xs={12} md={3} className='contact-form'>
                <h3 className='form-header'>Contact Us</h3>
                  <NotificationContainer />
                  <label htmlFor = 'name'>Name</label>
                  <input type = 'text' id = 'name' name = 'name' className='form-field' value={this.state.name} onChange={this.handleChange.bind(this)}/>
                  <label htmlFor = 'email'>E-Mail</label>
                  <input type = 'email' id = 'email' name = 'email' className='form-field' value={this.state.email} onChange={this.handleChange.bind(this)}/>
                  <label htmlFor = 'message'>How Can We Help?</label>
                  <textarea id = 'message' name = 'message' className = 'textarea' value={this.state.message} onChange={this.handleChange.bind(this)}/>
                  <button className='btn btn-primary submit-button' onClick = {this.handleSubmit}>Submit</button>
            </Col>
          </Row>
          <Row className='connected-products'>
            <Col xs={12} md={12}>
              <h2>Connected Products</h2>
              <p>
                Compared to Industrial IoT, connected devices are a relative newcomer to the scene. An example of a connected device would be a lamp in your 
                home, that you can control using your cell phone. The lamp contains circuitry that connects to your phone, either directly, or using your home 
                wireless internet.
              </p>
              <p>
                Home automation is a new and exciting market. Appliance manufacturers are introducing more and more advanced smart, connected devices that 
                can communicate valuable data to users, and each other. It is currently estimated there will be 28 billion connected devices by 2020. Increases 
                in miniaturization have also created an entirely new market in the wearables space, where sensors are designed into clothing and textiles.
              </p>
              <p>
                Whatever your connected product might be, KerBob can help with creating valuable hardware prototypes for your product. We can help with 
                product design, sensor and microcontroller selection, and connecting data to the internet. We can also design and create intuitive, 
                interactive web based dashboards and control panels for your connected products.
              </p>
            </Col>
          </Row>
          <Row className='modern-websites'>
            <Col xs={12} md={12}>
              <h2>Modern Websites</h2>
              <p>
                Every business needs a website, that goes without saying. And we would be remiss if we didn’t mention that we also do websites. We create 
                everything from simple company or product websites to complex, enterprise level web based applications.
              </p>
              <p>
                Featuring the very latest in web technologies, we create engaging and interactive user experiences for our customer’s products and services, 
                that sell. We also specialize in maintaining, updating, and reworking existing websites and applications.
              </p>
              <p>
                KerBob offers full stack web development services including React, Angular, and JavaScript of the front end, and Node JS, PHP, MySQL, 
                and MongoDB on the back end. We also design and implement REST API’s, using the back end technologies mentioned above.
              </p>
            </Col>
          </Row>
          <Row className='about-us equal'>
            <Col xs={12} md={12}>
              <h2>Why KerBob?</h2>
              <p>
                We keep up with the latest business and technology trends, always guaranteeing the very best in state of the art presence on the web 
                for our customers.
              </p>
              <p>
                In business over ten years, plus another 10+ years of experience in manufacturing and industrial environments, KerBob continually 
                strives to exceed customer’s expectations, deliver on time, and stay within budget. We have the resources to provide you with everything 
                your business needs. We focus on our customer’s success and ROI. We only win when our customers win!
              </p>
              <p>
                Let us know how we can help your business be the best it can be. <span className='bold italic red'>We're here to help!</span>
              </p>
            </Col>
          </Row>
        </div>
        <Row>
          <div className = 'footer'>
            <div className = 'copyright'>
              &copy;&nbsp;2018 KerBob Interactive Web Solutions, LLC
            </div>
          </div>
        </Row>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js